import { memo } from "react";
import PropTypes from "prop-types";
import "./ProductNameWithCategory.scss";

const ProductNameWithCategory = ({ name, category }) => {
	return (
		<p className="product-name-with-category" data-testid="product-name-with-category">
			{name}{" "}
			{category > 0 && (
				<>
					{category}
					<sup>*</sup>
				</>
			)}
		</p>
	);
};

ProductNameWithCategory.propTypes = {
	name: PropTypes.string,
	category: PropTypes.number,
};

export default memo(ProductNameWithCategory);
